import { render } from "./OpportunitiesContent.vue?vue&type=template&id=478c0131&scoped=true"
import script from "./OpportunitiesContent.vue?vue&type=script&lang=js"
export * from "./OpportunitiesContent.vue?vue&type=script&lang=js"

import "./OpportunitiesContent.vue?vue&type=style&index=0&id=478c0131&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478c0131"]])

export default __exports__